// IMPORTS
import axios from 'axios'
import Db from '@/dixie.js'
import Swal from 'sweetalert2'
import Router from '@/router'

const swalWithBootstrapButtons = Swal.mixin({
	customClass: {
		confirmButton: 'btn btn-xs btn-danger',
		cancelButton: 'btn btn-xs'
	},
	buttonsStyling: false
})

// DEFINITIONS
const state = {
	user: null
}

const getters = {
	isLogged: (state) => { return (!!state.user) },
	authToken: (state) => { 
		return (!!state.user && !!state.user.token)? state.user.token : null 
	}
}

const mutations = {
	authUpdate: (state, payload ) => {
		state.user = payload.user
		Db.configs.where('key').equalsIgnoreCase('user').delete().then(()=>{
			Db.configs.add({
				key: 'user',
				value: JSON.stringify(payload)
			})
		})
	},
	accountClean: (state) => {
		state.processing = false
		Db.configs.where('key').equalsIgnoreCase('token').delete()
		Db.configs.where('key').equalsIgnoreCase('user').delete()
		state.token = null
		state.user = null
	}
}

const actions = {
	recoverFromDixie: ({commit}) => {
		return new Promise(( success ) => {
			Db.configs.where('key').equalsIgnoreCase('user').first().then(user => {
				commit('authUpdate', JSON.parse(user.value))
				setTimeout(() => {
					success(true)
				}, 250)
			}).catch(() => {
				setTimeout(() => {
					success(false)
				}, 250)
			})
		})
	},
	authTryLogin: ( {commit}, payload ) => {
		return new Promise((success) => {
			axios.post('auth/trylogin', payload).then(response => {
				if(response.status){
					commit('authUpdate', response.data)
					success()
				} 
			})
		})
	},
	authTryLogout: ( {commit} ) => {
		swalWithBootstrapButtons.fire({
			title: '¿Seguro que deseas cerrar sesión y salir?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Finalizar sesión',
			cancelButtonText: 'Cancelar',
			reverseButtons: true
		}).then((result) => {
			if (result.value) {
				commit('accountClean')
				Router.push({name: 'Auth'})
				swalWithBootstrapButtons.fire(
					'¡Hasta pronto!',
					'Tu sesión ha sido terminada.',
					'success'
				)
			}
		})
	}
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};
